import { useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';
import { formatDateFromIso } from '@/lib/datetime';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

export default function WeightChart({ measurements }) {
    const chartData = useMemo(() => {
        return [...measurements]
            .filter(m => m.weight)
            .sort((a, b) => new Date(a.measured_at) - new Date(b.measured_at))
            .map(m => ({
                fecha: formatDateFromIso(m.measured_at),
                peso: parseFloat(m.weight),
                bmi: m.bmi ? parseFloat(m.bmi) : null,
            }));
    }, [measurements]);

    if (chartData.length === 0) return null;

    return (
        <Card className="bg-[#0a0a0a] border-hairline-dark mb-6">
            <CardHeader className="flex flex-row items-center gap-3 pb-2">
                <div className="h-8 w-8 bg-white/10 rounded-full flex items-center justify-center">
                    <TrendingUp className="h-4 w-4" />
                </div>
                <CardTitle className="text-sm font-semibold uppercase tracking-wide">Evolución del Peso</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="h-64 w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#3a3a3f" />
                            <XAxis dataKey="fecha" stroke="#5a5a5f" fontSize={12} />
                            <YAxis stroke="#5a5a5f" fontSize={12} domain={['auto', 'auto']} />
                            <Tooltip
                                contentStyle={{ backgroundColor: '#0a0a0a', border: '1px solid #3a3a3f', color: '#fff' }}
                                itemStyle={{ color: '#fff' }}
                            />
                            <Line type="monotone" dataKey="peso" stroke="#fff" strokeWidth={2} dot={{ r: 3, fill: '#fff' }} activeDot={{ r: 5 }} name="Peso (kg)" />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
        </Card>
    );
}
